import { Box } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../components/TableContent';

import { DividendHistoryItemTypes } from './types';

export const DividendHistoryItemMobile: React.FC<DividendHistoryItemTypes.Props> = ({ item }) => {
  const itemData = [
    { label: 'Tipo', value: item.dividendType },
    { label: 'Empresa', value: item.companyName },
    { label: 'ISIN', value: item.isinCode },
    { label: 'Cód. Neg.', value: item.negotiationCode },
    { label: 'Ativo', value: item.assetName },
    { label: 'Valor', value: item.assetValueNormalized },
    { label: 'Aprovação', value: item.approvalDateNormalized },
    { label: 'Início', value: item.startDateNormalized },
    { label: 'Atualização', value: item.updateDateNormalized },
    { label: 'Prazo Final', value: item.dueDateNormalized },
  ];

  return (
    <TableContent direction="column" space={0} py="stack.xxs" px="inline.xxxs" spaceX="inline.xxxs">
      {itemData.map((row, rowIndex) => (
        <>
          <TableContentItemColumn
            key={rowIndex}
            flex={1}
            direction="row"
            justifyContent="space-between"
            width="full">
            <TableContentItemText color="neutral.medium">{row.label}</TableContentItemText>
            <TableContentItemText>{row.value}</TableContentItemText>
          </TableContentItemColumn>
          {rowIndex < itemData.length - 1 && (
            <Box
              key="spacer"
              borderBottomColor="neutral.lightest"
              borderBottomWidth="1px"
              paddingTop="inset.nano"
              marginBottom="inset.nano"
              width="full"
            />
          )}
        </>
      ))}
    </TableContent>
  );
};
